import React from 'react';
import Button from '../../components/button/button.jsx';
import './overlay.scss'

export default class Overlay extends React.Component {

	constructor(props){
		super(props)

		this.state = {
			open : false
		}
	}

	componentDidMount(){
		window.addEventListener('Component.Overlay.Open', (e) => this.open(e), false);
		window.addEventListener('Component.Overlay.Close', (e) => this.close(), false);
	}

	render(){
		return 	<div className="component overlay" data-open={this.state.open}>
					<div className="inner">
						{this.state.content}

						<Button icon={'close'} clickEvent={'Component.Overlay.Close'}/>
					</div>
				</div>
	}

	open(e){
		window.dispatchEvent(new CustomEvent("Window.Scroll.Disabled"))
		this.setState({open: true, content : e.detail.content})
	}

	close(){
		window.dispatchEvent(new CustomEvent("Window.Scroll.Enabled"))
		this.setState({open: false})
	}

}


// WEBPACK FOOTER //
// ./src/components/overlay/overlay.jsx